import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sd-product-item-skeleton',
  templateUrl: './product-item-skeleton.component.html',
  styleUrls: ['./product-item-skeleton.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorProductItemSkeletonComponent {}
